export default {
  'app.member': '成员权限',
  'app.member.management': '成员管理',
  'app.member.management.search': '搜索成员',
  'app.member.management.invite': '邀请团队成员',
  'app.member.management.invite.sso.tip':
    '该组织已启用 SSO 登录，未曾授予过角色的成员将被自动Default 角色。您可以在成员加入后修改他的角色。',
  'app.member.management.invite.edit': '编辑成员',
  'app.member.management.invite.name.first': '名称',
  'app.member.management.invite.name.first.placeholder': `输入受邀人的名称`,
  'app.member.management.invite.name.first.validate': `请输入受邀人的名称`,
  'app.member.management.invite.name.last': '姓氏',
  'app.member.management.invite.name.last.placeholder': `输入受邀人的姓氏`,
  'app.member.management.invite.name.last.validate': `请输入受邀人的姓氏`,
  'app.member.management.invite.email': '邮件邀请成员',
  'app.member.management.invite.email.placeholder': `请输入邮箱，按 Enter 键添加`,
  'app.member.management.invite.email.validate.empty': `请输入受邀人的电子邮件`,
  'app.member.management.invite.email.validate.right': '请输入正确的邮箱',
  'app.member.management.invite.ssoConfig': '组织 SSO 服务',
  'app.member.management.invite.ssoConfig.placeholder': '选择该组织的 SSO 服务',
  'app.member.management.invite.ssoConfig.validate': '请选择一个该组织的 SSO 服务',
  'app.member.management.invite.role': '角色',
  'app.member.management.invite.role.placeholder': '选择一个该组织的角色',
  'app.member.management.invite.role.empty': '暂无任何角色',
  'app.member.management.invite.role.create': '去新增角色',
  'app.member.management.invite.role.validate': '请选择一个该组织的角色',
  'app.member.management.invite.ok': '确认',
  'app.member.management.invite.cancel': '取消',
  'app.member.management.table.name': '帐户名称',
  'app.member.management.table.id': '帐户ID',
  'app.member.management.table.status': '帐号状态',
  'app.member.management.table.status.enable': '启用',
  'app.member.management.table.status.disable': '停用',
  'app.member.management.table.status.wait': '待加入',
  'app.member.management.table.time.last': '最后访问时间',
  'app.member.management.table.time.create': '创建时间',
  'app.member.management.table.operation': '操作',
  'app.member.management.table.operation.detail': '详情',
  'app.member.management.table.operation.edit': '编辑',
  'app.member.management.table.operation.resend': '重发邀请',
  'app.member.management.table.operation.disable': '停用',
  'app.member.management.table.operation.enable': '启用',
  'app.member.management.table.operation.delete': '删除',
  'app.member.management.table.operation.delete.confirm': '删除后帐户不可用',
  'app.member.management.table.operation.delete.confirm.ok': '确认',
  'app.member.management.table.operation.delete.confirm.cancel': '取消',
  'app.member.management.table.operation.invite.success': '邀请成功',
  'app.member.role': '角色管理',
  'app.member.role.create': '建立角色',
  'app.member.role.edit': '修改角色',
  'app.member.role.creater.validate': '请输入角色名称',
  'app.member.role.create.placeholder': `输入角色名称`,
  'app.member.role.admin': '管理员',
  'app.member.role.rights': '权限明细',
  'app.member.role.members': '角色成员',
  'app.member.role.name.placeholder': '输入角色名称、该名称已被使用',
  'app.member.role.creater': '创建人',
  'app.member.role.console': '控制台',
  'app.member.role.empty': '暂未创建应用',
  'app.member.role.tip': '全局预置角色为每项专案的预先设定角色',
  'app.member.role.submit': '设定已成功！ ',
  'app.member.role.save': '保存成功！ ',
  'app.member.role.delete': '删除角色后，该角色下关联的成员权限将失效',
  'app.member.role.delete.ok': '删除',
  'app.member.role.delete.cancel': '取消',
  'app.member.role.members.table.search': '搜索筛选',
  'app.member.role.members.table.name': '帐户名称',
  'app.member.role.members.table.id': '帐户ID',
  'app.member.role.members.table.emial': '电子邮件',
  'app.member.role.members.table.status': '帐号状态',
  'app.member.role.members.table.status.enable': '启用',
  'app.member.role.members.table.status.disable': '停用',
  'app.member.role.members.table.status.wait': '待加入',
  'app.member.role.members.table.time.last': '最后访问时间',
  'app.member.role.members.table.time.create': '创建时间',
  'app.member.role.members.table.operation': '操作',
  'app.member.role.members.table.operation.detail': '详情',
  'app.member.role.members.table.operation.detail.title': '成员详情',
  'app.member.role.members.table.operation.detail.permission': '权限明细',
  'app.member.role.members.table.operation.delete': '移除角色',
  'app.member.role.permission.sharing': '所有应用共用角色权限',
  'app.member.role.permission.sharing.tip':
    '勾选之后再保存，该角色所具备的权限，在所有应用中均保持一致。',
  'app.member.management.create.org': '是否允许成员创建组织',
  'app.member.management.create.yes': '是',
  'app.member.management.create.no': '否',
  'app.member.roleCopy.copy': '复制角色',
  'app.member.roleCopy.title': '复制角色到其它组织',
  'app.member.roleCopy.select': '选择组织',
  'app.member.roleCopy.selectTip': '请选择组织',
  'app.member.roleCopy.all': '全选',
  'app.member.roleCopy.success': '复制成功！',
  'app.member.role.otp.target.tip': `<p>1）目标为手机号码时：</p>
    <p>当运营人员没有目标的查看权限时，打开历史记录看到的号码是被脱敏后的号码，当号码脱敏时，只展示号码字符串的前3个字节与后2个字节。</p>
    <p>2）目标为邮箱时：</p>
    <p>展示前2个字符，邮件地址从{'@'}后面开始一直保持不变。</p>
    <p>比如：</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>脱敏后，展示为：</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
